













































import Vue from 'vue';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { Exercise } from '@/models/exercise.model';
import { SetActivity } from '../models/exercise-activity.model';
import SetFields from '@/components/SetFields.vue';
import { EXERCISE_ACTIVITY_ADD_ACTION } from '../store/exercise-activity.store';

const newPlaceholder = () =>
  ({
    weight: 20,
    reps: 10,
    rpe: 5,
  } as SetActivity);

export default Vue.extend({
  components: { SetFields },
  data: function() {
    return {
      filter: '',
      title: this.$route.name,
      selectedExercise: null as Exercise | null,
      sets: [newPlaceholder()] as SetActivity[],
    };
  },
  computed: {
    // Need type annotation for computed/methods, type inferencing not good enough
    filteredExercises(): Exercise[] {
      const store: Store<AppState> = this.$store;
      const exercises = store.state.exercise.exercises;
      if (this.filter) {
        return exercises.filter(e => e.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1);
      } else {
        return exercises;
      }
    },
  },
  methods: {
    addSet(): void {
      this.sets.push(newPlaceholder());
    },
    removeSet(index: number): void {
      this.sets.splice(index, 1);
    },
    saveExerciseActivity(): void {
      if (!this.selectedExercise) {
        return;
      }

      // TODO: make payload interfaces
      const exerciseActivity = {
        id: '',
        exerciseId: this.selectedExercise.id,
        sets: this.sets,
      };

      this.$store.dispatch(EXERCISE_ACTIVITY_ADD_ACTION, {
        database: this.$database,
        exerciseActivity: exerciseActivity,
      });

      this.filter = '';
      this.selectedExercise = null;
      this.sets = [];
    },
  },
});
